<template>
  <el-dialog :title="$t('common.operation')" :visible.sync="visible" width="500px">
    <p>{{ $t('feeConfigManage.confirmDeleteFeeItem') }}</p>

    <div slot="footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteFeeConfig">{{ $t('common.delete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteFeeConfig } from '@/api/fee/feeConfigManageApi'

export default {
  name: 'DeleteFeeConfig',
  data() {
    return {
      visible: false,
      configId: ''
    }
  },
  methods: {
    open(feeConfig) {
      this.configId = feeConfig.configId
      this.visible = true
    },

    async deleteFeeConfig() {
      try {
        await deleteFeeConfig({
          configId: this.configId,
          communityId: this.getCommunityId()
        })

        this.$message.success(this.$t('common.operationSuccess'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        this.$message.error(error.message || this.$t('common.deleteFail'))
      }
    }
  }
}
</script>